<template>
    <vue-multiselect
        :model-value="selected"
        :options="selectOptions"
        :show-labels="false"
        :searchable="false"
        label="label"
        track-by="code"
        @update:model-value="onSelected"
        :allow-empty="false"
        class="rounded-sm border border-gray-light font-sans text-[16px]"
    />
</template>

<script>
    import VueMultiselect from 'vue-multiselect';
    import 'vue-multiselect/dist/vue-multiselect.css';

    export default {
        components: {
            VueMultiselect,
        },

        emits: ['input'],

        computed: {
            selected() {
                return this.selectOptions.find((x) => x.selected);
            },
        },

        props: {
            selectOptions: {
                type: Array,
                required: true,
            },
        },

        methods: {
            onSelected(v) {
                this.$emit('input', v);
            },
        },
    };
</script>

<style lang="scss">
    #cz3 {
        .multiselect,
        .multiselect__tags {
            @apply text-black;
            min-height: 46px;
        }

        .multiselect {
            transition: border 0.25s ease-out;
        }

        .multiselect.multiselect--active {
            border-color: #000;
        }

        .multiselect__single,
        .multiselect__placeholder {
            font-size: 16px;
            @apply m-0;
        }

        .multiselect__element {
            font-size: 16px;
        }

        .multiselect__select {
            @apply h-full;

            display: flex;
            justify-content: center;
            align-items: center;

            &::before {
                border-width: 5px 5px 0 5px;
                border-color: black transparent transparent transparent;
            }
        }

        .multiselect__tags {
            @apply pt-0 flex items-center;
        }

        .multiselect__content-wrapper {
            @apply -left-px rounded-sm border border-solid border-black;

            width: calc(100% + 2px);

            border: 1px solid #dfdfdf;
            border-top: 1px solid #000;
        }

        .multiselect__option {
            @apply px-2 py-3 flex items-center font-sans;
        }

        .multiselect__option.multiselect__option--highlight {
            background-color: #f0f0f0;

            @apply text-black;
        }

        .multiselect__option.multiselect__option--selected {
            background-color: #f0f0f0;

            @apply text-black;

            font-weight: 400;
        }

        .multiselect__select::before {
            content: url(@/assets/images/icons/dropdown-arrow.svg);

            display: inline-block;

            top: 0;
            padding: 0;
            margin: 0;

            width: 12px;

            transform: rotate(0deg);

            visibility: visible;
            border: none;
        }

        .multiselect__element {
            padding: 0;
        }
    }
</style>
